module.exports = "https://trybtryb-legacy.web.app/img/shopping-cart.e501a74e.svg";